import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../../common/constants';
import utils from '../../../../common/utils';

export default class GetTenantFeatureService extends BaseService {
  constructor() {
    super(constants.GET_TENANT_FEATURE_DATA, 'getTenantFeatureStatus');
  }

  handleEvent(eventName, event) {
    const headers = utils.buildHeadersWithTenantId(event);
    return this.getClient('aiadmin').get(`/aiadmin/tenant/feature`, { headers });
  }

  handleResponse(response) {
    Framework.getStoreRegistry().getStore('tenantFeature').setResponse(response);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: 'Error in Retreiving Features',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }
}
